/* Copyright(c) 2025 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/**
 * @file permittedAssetsReport 
 * @author  Rutuja Jagtap - 5573
 * @section DESCRIPTION permitted Assets Report
 */

import React from "react";
import Navigation from "../layouts/MBAdminNavPage";
import Footer from "../layouts/footer";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom';
// import "./LeadFileTrackingReport.css"
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";
import { saveAs } from "file-saver";
import {  Table} from 'antd';
import { css } from "emotion";
import { FaArrowAltCircleLeft } from "react-icons/fa";

const xlsx = require("xlsx");
const Swal = require('sweetalert2');

const tableCSS = css({
    backgroundColor: "white",
    fontFamily: "sans-serif",
    borderStyle: "bold",
    "& thead  > tr": {
      backgroundImage: "linear-gradient(to right,#28166f,#007cc3) !important",
      // backgroundColor:'#193D8F-#007CC3(linear gradient) !important',
      color: "white",
      fontSize: "12px",
      textAlign: "center",
      fontWeight: "500",
    },
    "& thead > tr >th": {
      textAlign: "center",
      color: "white",
      // backgroundColor:'#193D8F-#007CC3(linear gradient) !important',
    },
  });

class permittedAssetsReport extends React.Component {
  constructor() {
    super();
    this.state = {
      reportDetails: [],
      loader_progress: "",
      tableState: { size: "small" },
      UserName: [],
      selectedUser: '',
      reportDetailsSearch:[],
      tableSearchText: "",
      pageSize: 25, 

    }
    this.NameHandleChange = this.NameHandleChange.bind(this); 
    this.searchHandleChange = this.searchHandleChange.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
  }
 //Rutuja 5573 handle change after selecting user 
  NameHandleChange(e) {
    e.preventDefault();
    if(e.target.value!=="Select Publisher"){
        this.setState({ selectedUser : this.state.UserName[e.target.value], reportDetails :[]});

    }
   
    }
 /**
   * @author :Rutuja Jagtap - task 5573
   * @description : fetch the permitted asset report
   */
  searchHandleChange(e) {
    let user = this.state.selectedUser;
        if((user !== (undefined || ""))){ 
        
        this.setState({ loader_progress: "loader_campaign_list" });
        let data = {
            user: user,
        }
        fetch("/admin/permittedAssetReport", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
        body: JSON.stringify(data)
        }).then(res => res.json())
        .then(reportDetails => {
          if(reportDetails.length>0){   
            this.setState({ loader_progress: "" });
            this.setState({ reportDetails: reportDetails, })
          }else{
              Swal.fire({
                  type: "warning",
                  title: "No records Found",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                  preConfirm: () => {
                    window.location.reload();
                  },
                  
            });
            this.setState({ loader_progress: "" });
          }
        }).catch(function (err) { console.log(err) });
      }else{
        Swal.fire({
          type: "warning",
          title: "Please Select All Mandatory Fields",
          confirmButtonText: "Ok",
          allowOutsideClick: false
        });
        this.setState({ loader_progress: "" });
      }
      }
/**
   * @author :Rutuja Jagtap - task 5573
   * @description : filter the data according to search data
   */
      
      handleChangeSearch(e) {
		e.preventDefault();
		let currentList = [];
		// Variable to hold the filtered list before putting into state
		let newList = [];
		let filterData = e.target.value;
		// If the search bar isn't empty
		if (e.target.value === "") {
			newList = this.state.reportDetails;
		} else {
			// Assign the original list to currentList
			currentList = this.state.reportDetails;
			newList = currentList.filter((item) => {
				let obj = {};//Somnath Task-3972, Add specific Keys in search criteria
				obj[`campID`] = item.campID;
				obj[`actionByName`] = item.actionByName;
                obj[`description`] = item.description;
                obj[`created`] = item.created;
                obj[`reason`] = item.reason;
				// change current item to lowercase
				const lc = obj;
				// change search term to lowercase
				const filter = e.target.value.toLowerCase();
				// check to see if the current list item includes the search term
				// If it does, it will be added to newList. Using lowercase eliminates
				// issues with capitalization in search terms and search content
				var data = Object.values(lc);
				var dataFinal = data.toString();
				dataFinal = dataFinal.replace(",", " ");
				var dataToLower = dataFinal.toLowerCase();
				return dataToLower.includes(filter);
			});
		}
		// Set the filtered state based on what our rules added to newList
		this.setState({
			reportDetailsSearch: [...newList],
            tableSearchText: filterData,
		});
	}
    handleChangePageSize(e) {
        var pageSize = e.target.value;
        this.setState({ pageSize: pageSize });
      }

  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.history.push('/userLogin');
    }
    else{
        const { isAuthenticated } = this.props.auth;
        var reportType = this.state.reportType;
              this.setState({ loader: "loader_report" })
            //Rutuja 5573 fetch all pc user details
              fetch("/admin/allPccUserDetails", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
              }).then((res) => res.json())
                .then((UserNameDetails) => {
                  // alert("UserNameDetails -->" + JSON.stringify(UserNameDetails))
                  this.setState({ allUserNames: UserNameDetails});
                  let userNameArray = [];
                  if(UserNameDetails.length>0)
                  {
                    for(let i=0;i<UserNameDetails.length;i++){
                      userNameArray.push({firstName:UserNameDetails[i].firstName,lastName:UserNameDetails[i].lastName}); //Rutuja task 5573 re
                    }
                    userNameArray = Array.from(
                      new Set(
                        userNameArray.map((el) =>
                          JSON.stringify(el)
                        )
                      )
                    ).map((el) => JSON.parse(el));
                  }
                  this.setState({ UserName: userNameArray})
                }).catch(function (err) { console.log(err) ;});
    }
   
  }
 
  
  render() {
    const asterisk = { color: 'red' }
    const { isAuthenticated, user } = this.props.auth;
    const columnsReport = [
     
      {
          title: <span>Date&nbsp;&nbsp;&nbsp;</span>,
          dataIndex: "Date",
          key: "Date",
          width: "20%",
          align: "center",
          render: (text, record) => (
              <div>
                  <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
                      {record.created}
                  </span>
                  <br />
              </div>
          ),
      },
      {
          title: <span>Campaign ID&nbsp;&nbsp;&nbsp;</span>,
          dataIndex: "campID",
          key: "campID",
          width: "10%",
          align: "center",
          render: (text, record) => (
              <div>
                  <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
                      {record.campID}
                  </span>
                  <br />
              </div>
          ),
      },
      {
        title: <span>Description&nbsp;&nbsp;&nbsp;</span>,
        dataIndex: "description",
        key: "description",
        width: "30%",
        align: "center",
        render: (text, record) => (
            <div>
                <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
                    {record.description}
                </span>
                <br />
            </div>
        ),
      },
      {
        title: <span>Reason&nbsp;&nbsp;&nbsp;</span>,
        dataIndex: "reason",
        key: "reason",
        width: "25%",
        align: "center",
        render: (text, record) => (
            <div>
                <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
                    {record.reason}
                </span>
                <br />
            </div>
        ),
      },
      {
        title: <span>Action By&nbsp;&nbsp;&nbsp;</span>,
        dataIndex: "action",
        key: "action",
        width: "15%",
        align: "center",
        render: (text, record) => (
            <div>
                <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
                    {record.actionByName}
                </span>
                <br />
            </div>
        ),
    },
     
    ]
    function onChange(pagination, filters, sorter) {
        console.log("params", pagination, filters, sorter);
      }
    return (
    <div>
      <Navigation />
        <div class="container-fluid" style={{ paddingTop: '100px' }}>

        {/* heading section */}
          <div class="row">
               
              <div align="center" class="col-lg-2 col-md-2 col-sm-2" 
                           style={{
                             color: "#056eb8",
                             backgroundColor: "rgb(245 245 245)",
                           }}
                         >
                           <a
                             href="#/"
                             onClick={(e) => {
                               e.preventDefault();
                               this.props.history.push("/LeadFileTrackingReport", {
                                 });
                             }}
                             style={{
                               color: "#056eb8",
                               flex: "0 0 auto",
                               backgroundColor: "rgb(245 245 245)",
                               position: "sticky",
                             }}
                           >
                             <FaArrowAltCircleLeft
                               size={32}
                            //    style={{ marginLeft: "15%", marginTop: "5%" }}
                               title="Back to Lead file tracking report"
                             />
                           </a>
                         </div>     
            <div class="col-lg-8 col-md-8 col-sm-8" align="center">
              {/* Chaitanya-5606-Changed Permitted Assets Report to Mandatory Assets Report */}
              <center><label id="labelDI" style={{ fontSize: '28px', fontStyle: 'roboto', fontWeight: '500', color: '#193D8F' }} align="center">Mandatory Assets Report</label></center>
            </div>
          </div>
          
        <div className="Main-body">  
          <div class="container-fluid" style={{ paddingTop: '10px', marginBottom: '20px' }}>
            <div className="card card-signin my-1" style={{  width: "85%",   marginLeft: "auto",   marginRight: "auto", }}>
              <div className="card-body"  >
             
                {/* Filter section */}          
                <div className="row" >
                <div align="right" className="col-12 col-sm-6 col-md-6 col-lg-5 "  >
                <br/>           
                <label style={{ fontSize: '16px', color: '#193D8F', fontFamily: 'sans-serif' }}>
                      Select User :<span style={asterisk}>*</span>
                  </label>
                  &nbsp;&nbsp;
                  <select  
                      style={{
                          width: '230px',
                          height: "34px",
                          border: '1px solid #cccccc',
                          backgroundColor: "#FFFFFF",
                          borderRadius: '3px',
                          fontFamily: 'sans-serif',
                          color: '#555555'
                      }} 
                      onChange={this.NameHandleChange}
                      >
                      <option value={"Select Publisher"}>Select User</option>
                      {this.state.UserName.map((user, i) => (
                          <option value={i} key={i} style={{ fontSize: "14px", fontFamily: "sans-serif", color: "#555555" }}>
                              {user.firstName} {user.lastName}
                          </option>
                      ))}
                  </select>
                    </div>

                   
                    <div align="right"  className="col-12 col-sm-6 col-md-6 col-lg-6 " > 
                    <br/>           
                          <button
                            type="button"
                            class="btn add-button"
                            style={{ width:"140px" }}
                            onClick={this.searchHandleChange}>
                            Search
                          </button>
                    </div>  
                    </div>
                   
                    <div className="row" align="center"  id={this.state.loader_progress}></div>   
                    {/* <div className="row"> */}
                            
                             <div align="right" className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <input
                                id="search-bar1"
                                type="text"
                                style={{
                                    backgroundImage: "url(Group_294.png)",
                                    backgroundPosition: "15px 6px",
                                    backgroundSize: "15px 15px",
                                    backgroundRepeat: "no-repeat",
                                    width: "20%",
                                    height: "20px",
                                    fontSize: "10px",
                                    border: "1px solid #ddd",
                                    padding: "12px 20px 12px 34px",
                                    borderRadius: "25px",
                                    backgroundColor: "rgb(221, 221, 221)",
                                }}
                                onChange={this.handleChangeSearch}
                                onPressEnter={this.handleChangeSearch}
                                placeholder="Search..."
                                title="Type in a name"
                                />
                            </div>
                        <br/>  <br/> 
                            {/* <div className="col-lg-12"> */}
                            <div
              class="table-responsive"
              
            >

                                <Table
                                {...this.state.tableState}
                                id="myTable"
                                bordered
                                dataSource={
                                    this.state.tableSearchText === ""
                                      ? this.state.reportDetails
                                      : this.state.reportDetailsSearch
                                  }
                                // dataSource={this.state.reportDetails}
                                columns={columnsReport}
                                onChange={onChange}
                                scroll={
                                    (this.state.tableSearchText === "" ? this.state.reportDetails : this.state.reportDetailsSearch).length > 0
                                      ? { y: 500,x:500 } // Scroll when there is data
                                      : undefined  // No scroll when empty
                                  }
                                 className={`${tableCSS} "table-responsive"`}
                                pagination={{
                                    pageSize: this.state.pageSize,
                                    position: "bottom",
                                  }}
                                /> 
                            {/* </div> */}
                           
                            
                
                        {/* </div> */}

                        {/* <div class="row"> */}
                        {this.state.reportDetails.length > 0 ? (
            <div
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
              style={{ marginTop: "-53px", marginLeft: "5px" }}
            >
              &nbsp;Records per page : &nbsp;
              <select
                defaultValue={this.state.pageSize}
                onChange={this.handleChangePageSize}
                id="pacing1"
                class="input-small"
                className="form-control"
                name="pacing"
                style={{ width: "71px", height: "30px", display: "initial" }}
              >
                <option value="25" selected>
                  25
                </option>
                <option value="50">50</option>
                <option value="75">75</option>
              </select>
            </div>
            ):""  }
          </div>
              </div>
            </div>
          </div>
        </div>
                        
      </div>
      <Footer />
    </div>
    );
  }
}


permittedAssetsReport.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  auth: state.auth
})
export default connect(mapStateToProps, { logoutUser })(withRouter(permittedAssetsReport));

